import { useContext } from 'react';

import { DashboardContext } from './DashboardContextProvider';

const useDashboardContext = () => {
  const context = useContext(DashboardContext);

  if (context === undefined) {
    throw new Error(
      'useDashboardContext must be used within a DashboardContextProvider (included on DashboardRoot)',
    );
  }

  return context;
};

export default useDashboardContext;
